module.exports = __webpack_public_path__ + "static/AngelaHe14-9b4303ee711963ca3ff73a87ecd54e29.png";